export const colors = ['#7D23A1', '#5A1F72', '#491D5B'];

export const stub = colors.map((color) => ({ title: 'APR', color }));
